module.exports = __webpack_public_path__ + "media/categories/1061-3ba92969.svg";